import {frameworkOverlay} from "../../../core/components/overlay/configuration/overlayconfiguration"
import {overlayAssetConfig} from "../../../data/overlay";
import {objectTypes} from "../../../core/components/buttonpanel/interface/Ibuttons";


frameworkOverlay.data = {

    "COMPONENTS": [
        {
            "id": "overlayGenericUIContainer",
            "name": "overlayGenericUIContainer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "baseLayer",
            child: [
                {
                    "id": "overlayGenericUIComponent",
                    "name": "OverlayGenericUI",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [
                        {
                            "id": "canvasAutoplayTag",
                            "name": "CanvasAutoplay",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        /* {
                            "id": "CanvasDesktopSettingPanelTag",
                            "name": "CanvasDesktopSettingPanel",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        }, */
                    ]
                }
            ]
        }
    ],


}